/* PowerGo pre-order pricing: Shopify selling-plan allocations are the source of truth.
   This file only changes display; Timesact owns discounts and checkout. */
(function () {
  'use strict';

  function initialize(root) {
    var sectionId = root.getAttribute('data-section-id');
    var dataNode = document.getElementById('ProductJson-' + sectionId);
    var chargeNode = document.getElementById('PgSellingPlanCharges-' + sectionId);
    var form = root.querySelector('form[action*="/cart/add"]');
    var area = root.querySelector('[data-pg-preorder-price-area]');
    if (!dataNode || !form || !area) return;
    var product;
    try { product = JSON.parse(dataNode.textContent); } catch (e) { return; }
    if (!product || !Array.isArray(product.variants)) return;
    var checkoutCharges = [];
    try { checkoutCharges = chargeNode ? JSON.parse(chargeNode.textContent) : []; } catch (e) { checkoutCharges = []; }
    if (!Array.isArray(checkoutCharges)) checkoutCharges = [];
    var panel = area.querySelector('[data-pg-preorder-pricing]');
    if (!panel) return;
    var currency = root.getAttribute('data-pg-currency') || 'USD';
    var formatter;
    try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }); }
    catch (e) { formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
    var money = function (cents) { return formatter.format(cents / 100); };
    var lastSignature = '';
    var lastRenderKey = '';

    var offerContainer = null;
    function syncOfferContainer(active) {
      if (active) {
        if (offerContainer && offerContainer.isConnected) return;
        var priceRow = area.closest('.row.type_price');
        var buyRow = form.querySelector('.row.type_buy_buttons');
        if (!priceRow || !buyRow || priceRow.parentNode !== buyRow.parentNode) return;
        var cursor = priceRow, between = [];
        while (cursor && between.length < 30) {
          between.push(cursor);
          if (cursor === buyRow) break;
          cursor = cursor.nextElementSibling;
        }
        if (between[between.length - 1] !== buyRow) return;
        offerContainer = document.createElement('div');
        offerContainer.className = 'pg-preorder-offer-container';
        priceRow.parentNode.insertBefore(offerContainer, priceRow);
        between.forEach(function (node) { offerContainer.appendChild(node); });
      } else if (offerContainer && offerContainer.isConnected) {
        var parent = offerContainer.parentNode;
        while (offerContainer.firstChild) parent.insertBefore(offerContainer.firstChild, offerContainer);
        offerContainer.remove();
        offerContainer = null;
      }
    }

    var depositDetails = document.createElement('div');
    depositDetails.className = 'pg-preorder-deposit-details';
    depositDetails.hidden = true;

    function selectedVariant() {
      var idInput = form.querySelector('select[name="id"], input[name="id"]:checked, input[name="id"]');
      var id = idInput && idInput.value;
      var byId = product.variants.find(function (v) { return String(v.id) === String(id); });
      // This theme uses separate option selectors and a no-JS variant select.
      // Match selected option values when the hidden select is stale.
      var selectors = Array.prototype.slice.call(form.querySelectorAll('.selector-wrapper.js fieldset.single-option-radio, .selector-wrapper.js select.single-option-selector'));
      if (selectors.length) {
        var chosen = selectors.map(function (node) {
          if (node.matches('fieldset')) {
            var checked = node.querySelector('input:checked');
            return checked && checked.value;
          }
          return node.value;
        });
        if (chosen.every(Boolean)) {
          var matched = product.variants.find(function (v) {
            return chosen.every(function (value, index) { return v.options && v.options[index] === value; });
          });
          if (matched) return matched;
        }
      }
      return byId || (product.variants.length === 1 ? product.variants[0] : null);
    }

    // Presentation-only reordering. Keep Timesact's own elements and event handlers.
    function placeEtaAboveTimer() {
      var timer = form.querySelector('.timesact-timer-preOrder');
      var eta = form.querySelector('.timesact-preOrder-message');
      if (!timer || !eta || timer.parentNode !== eta.parentNode) return;
      if (eta.nextElementSibling !== timer) timer.parentNode.insertBefore(eta, timer);
    }

    function update() {
      placeEtaAboveTimer();
      var button = form.querySelector('.timesact-preOrder-button');
      var planInput = form.querySelector('input[name="selling_plan"][data-timesact-selling-plan]:checked');
      var variant = selectedVariant();
      var allocations = variant && Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
      // When Timesact disables split payments, it may omit the selling-plan radio.
      // Use a unique Shopify allocation only; never guess among multiple offers.
      var allocation = planInput
        ? allocations.find(function (a) { return String(a.selling_plan_id) === String(planInput.value); })
        : (allocations.length === 1 ? allocations[0] : null);
      var regular = variant && Number(variant.price);
      var discounted = allocation && Number(allocation.price);
      var valid = !!(button && !button.disabled && allocation && Number.isFinite(regular) && Number.isFinite(discounted) && discounted >= 0 && discounted < regular);
      var signature = valid ? [variant.id, allocation.selling_plan_id, regular, discounted, variant.compare_at_price].join(':') : 'inactive';
      var charge = allocation && checkoutCharges.find(function (c) { return String(c.id) === String(allocation.selling_plan_id); });
      var renderKey = signature + ':' + (charge ? [charge.value_type, charge.value].join(':') : 'unknown') + ':' + !!form.querySelector('.timesact-selling-plan-widget');
      if (renderKey === lastRenderKey) return;
      lastRenderKey = renderKey;
      lastSignature = signature;
      if (!valid) {
        depositDetails.hidden = true;
        panel.hidden = true;
        area.classList.remove('pg-preorder-pricing-active');
        syncOfferContainer(false);
        return;
      }
      var saved = regular - discounted;
      var percent = Math.round(saved / regular * 100);
      var msrp = Number(variant.compare_at_price);
      var msrpWrap = panel.querySelector('[data-pg-preorder-msrp]');
      msrpWrap.hidden = !(Number.isFinite(msrp) && msrp > regular);
      if (!msrpWrap.hidden) panel.querySelector('[data-pg-preorder-msrp-value]').textContent = money(msrp);
      panel.querySelector('[data-pg-preorder-regular]').textContent = money(regular);
      panel.querySelector('[data-pg-preorder-price]').textContent = money(discounted);
      panel.querySelector('[data-pg-preorder-badge]').textContent = 'Extra ' + percent + '% off';
      panel.querySelector('[data-pg-preorder-savings]').textContent = 'Save ' + money(saved) + ' with pre-order';
      panel.hidden = false;
      area.classList.add('pg-preorder-pricing-active');
      syncOfferContainer(true);

      // Shopify's selling-plan checkout charge is the source of truth, not the
      // merchant-editable Timesact label. Unknown terms must not show estimates.
      var widget = form.querySelector('.timesact-selling-plan-widget');
      var due = null;
      if (charge && charge.value_type === 'percentage') {
        var percentage = Number(charge.value);
        if (Number.isFinite(percentage) && percentage > 0 && percentage < 100) {
          due = Math.round(discounted * percentage / 100);
        }
      } else if (charge && charge.value_type === 'price') {
        var fixed = Number(charge.value);
        if (Number.isSafeInteger(fixed) && fixed > 0 && fixed < discounted) {
          due = fixed;
        }
      }
      if (widget && due !== null) {
        var remaining = discounted - due;
        depositDetails.innerHTML = '<div><span>Estimated due today</span><strong>' + money(due) + '</strong></div>' +
          '<div><span>Estimated remaining balance when shipped</span><strong>' + money(remaining) + '</strong></div>' +
          '<small>Calculated before applicable taxes and shipping. Confirm payment terms at checkout.</small>';
        if (depositDetails.parentNode !== widget) widget.appendChild(depositDetails);
        depositDetails.hidden = false;
      } else {
        depositDetails.hidden = true;
      }
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; update(); });
    }
    form.addEventListener('change', schedule);
    form.addEventListener('input', schedule);
    // Timesact injects its controls asynchronously and may replace them on variant change.
    var observer = new MutationObserver(schedule);
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'checked', 'value'] });
    schedule();
  }

  function start() {
    document.querySelectorAll('.content.product[data-section-id]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
